export class MaterialType {
    constructor(private _materialTypeId: string, private _description: string, private _description2: string) {

    }

    get materialTypeId(): string {
        return this._materialTypeId;
    }


    set materialTypeId(val: string) {
        this._materialTypeId = val;
    }

    get description(): string {
        return this._description;
    }

    set description(val: string) {
        this._description = val;
    }

    get description2(): string {
        return this._description2;
    }

    set description2(val: string) {
        this._description2 = val;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/materialDialog/models/materialType.ts
 **/